import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CurrencySymbol } from '../../../Utility/Constants'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useHistory, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Loader from '../../../Components/Loader'
import { data } from '../../FrontOffice/Billing/CommonBilling/data'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

const fieldLimits = {
    templateCode: 50,
    templateName: 50,
    serviceName: 50,
    serviceCode: 50,
};

export default function AddTemplateConfig() {
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Template Configuration", "SubTab")?.editAccess
    const location = useLocation();
    const TempId = location.state?.id;
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [formState, setFormState] = useState({
        templateCode: '',
        templateName: '',
        serviceName: '',
        serviceCode: '',
        searchList: [],
        serviceSearch: '',
        serviceSearchData: null,
        ModuleType: [],
        appliesTo: null
    });
    const [isActive, setIsActive] = useState(true);
    const [templateId, setTemplateId] = useState(null);
    const [serviceList, setServiceList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [serviceDetails, setServiceDetails] = useState([]);
    const [templateLineItem, settemplateLineItem] = useState(null)
    const [apiDeleteIDs, setapiDeleteIDs] = useState(null)
    const [localDeleteIDs, setlocalDeleteIDs] = useState(null)

    useEffect(() => {
        if (TempId) {
            getTemplateIndividual();
        }
    }, [TempId]);

    useEffect(() => {
        if (formState?.serviceSearch.length > 0) {
            getSearchData();
        }
    }, [formState?.serviceSearch])

    useEffect(() => {
        getModuleList();
    }, [])

    const getSearchData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.CONFIGURATION_SERVICE_SEARCH + `?search_key=${formState?.serviceSearch}&module_type=${formState?.appliesTo}&all_doctor=${true}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFormState((prevState) => ({ ...prevState, searchList: response.data.data || [], }));
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }


    const getTemplateIndividual = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_TEMPLATE_CONFIGURATION + `?get_type=individual&template_id=${TempId}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFormState((prevState) => ({
                            ...prevState,
                            templateCode: response.data.data?.template_code,
                            templateName: response.data.data?.template_name,
                            appliesTo: response.data.data?.apply_for
                        }));
                        setIsActive(response.data.data?.is_active)
                        setServiceList(response.data.data || [])
                        setServiceDetails(response.data.data?.line_item || [])
                        const templateLineItemIds = response.data.data?.line_item
                            .map(service => service.template_details_id)
                            .filter(id => id !== null && id !== undefined);
                        settemplateLineItem(templateLineItemIds);
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getModuleList = () => {
        try {
            RestAPIService.getAll(Serviceurls.MODULE_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const ModuleData = response.data.data || [];
                        const keysToRemove = ["IP", "IP_OP"];
                        const filteredKeys = Object.keys(ModuleData).filter(key => !keysToRemove.includes(key));
                        setFormState((prev) => ({
                            ...prev,
                            ModuleType: filteredKeys
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'serviceSearchData':
                setFormState((prevState) => ({
                    ...prevState,
                    "serviceSearchData": val,
                    'departmentType': val?.department_type,
                    'serviceHeadCode': val?.service_head_code,
                    'serviceHead': val?.service_head_name,
                    'serviceName': val?.service_name,
                    'serviceCode': val?.service_code,
                    'serviceId': val?.id
                }));
                break
            case 'appliesTo':
                setFormState((prevState) => ({
                    ...prevState,
                    appliesTo: val,
                    serviceSearchData: null,
                    searchList: []
                }));
                break
        }
    }

    const onChangeHandler = (e, name) => {
        const { value } = e.target;

        if (value === "" || value.length <= (fieldLimits[name] || 50)) {
            setFormState((prevState) => ({ ...prevState, [name]: value }));
        }
    };


    const textBox = (label, name, val, width, disable = false, Symbol = null) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    autoComplete='off'
                    value={val ? val : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    InputProps={Symbol ? {
                        style: { paddingRight: '0.5vw' },
                        endAdornment:
                            Symbol === 'rupee' ?
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{CurrencySymbol}</Typography> :
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>%</Typography>

                    } : null}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width) => {
        return (
            <Box>
                <Autocomplete
                    clearIcon
                    size={'small'}
                    options={list}
                    name={name}
                    disabled={(name === 'serviceSearchData' && !formState?.appliesTo) || (name === 'appliesTo' && TempId) || (name === 'appliesTo' && serviceDetails.length > 0)}
                    getOptionLabel={(option) => {
                        if (name === 'serviceSearchData') {
                            return `${option?.service_head_name || option?.service_head} ${option?.service_head_code ? `(${option?.service_head_code})` : ''} - ${option?.service_name} ${option?.service_code ? `(${option?.service_code})` : ''}`;
                        }
                        const moduleMapping = {
                            IP: "IN PATIENT",
                            OP: "OUT PATIENT",
                            IP_OP: "BOTH IP & OP",
                            LAB: "LABORATORY"
                        };

                        return moduleMapping[option] || option;
                    }}
                    value={val}
                    onInputChange={(e, newInputValue) => {
                        if (name === 'serviceSearchData') {
                            newInputValue && setFormState((prevState) => ({ ...prevState, serviceSearch: newInputValue }));
                        }                        
                    }}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const TableHeaderBtns = () => {
        return (
            <Box>
                {/* <Tooltip title="Filter" placement='top' arrow>
                    <IconButton onClick={() => { setFilterOpen(true) }}><FilterAltIcon color='primary' /></IconButton>
                </Tooltip> */}
            </Box>
        )
    }
    const grpDelete = () => {
        setisDelete(true)
    }

    const tableView = () => {

        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText renderComponent={TableHeaderBtns} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = serviceDetails.filter((row) => selectedIDs.has(row.sno));
            let finalData = selectedRows.map(item => ({
                id: item.service_details_id,
                template_details_id: item.template_details_id || null
            }));
            setdelIDs(finalData)
            setapiDeleteIDs(finalData.filter(item => item.template_details_id).map(item => item.template_details_id));
            setlocalDeleteIDs(finalData.filter(item => !item.template_details_id).map(item => item.id));
        }

        serviceDetails?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'service_head', headerName: 'Service Head Details', flex: 0.18,
                valueGetter: (params) => {
                    const name = params.row.service_head_name || params.row.service_head;
                    const code = params.row.service_head_code;
                    return name ? `${code ? code + ' - ' : ''}${name}` : '-';
                },
                renderCell: (params) => {
                    const serviceHeadName = params.row.service_head_name || params.row.service_head;
                    return (serviceHeadName ? serviceHeadName.length > 70 || params.row.service_head_code.length > 70 ?
                        <Tooltip placement="top" title={`${params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}${serviceHeadName}`}><Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{serviceHeadName.slice(0, 67) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{serviceHeadName}</Typography> : '-')
                }
            },
            {
                field: 'service_name', headerName: 'Service Name Details', flex: 0.18,
                renderCell: (params) => (params.row.service_name ? params.row.service_name.length > 70 || params.row.service_code.length > 70 ?
                    <Tooltip placement="top" title={`${params.row.service_code ? params.row.service_code + ' - ' : ''}${params.row.service_name}`}><Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name.slice(0, 67) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name}</Typography> : '-')
            },
        ]
        return (
            <Box sx={{ height: '42vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={serviceDetails}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const AddTable = () => {
        let newData = {
            template_details_id: formState?.serviceSearchData?.template_id || null,
            service_details_id: formState.serviceSearchData?.service_details_id,
            service_name: formState.serviceSearchData?.service_name,
            service_head_name: formState.serviceSearchData?.service_head_name,
            service_head_code: formState.serviceSearchData?.service_head_code,
            service_code: formState.serviceSearchData?.service_code,
            module_type: formState.serviceSearchData?.module_type,
            template_id: templateId,
            is_sharable: formState.serviceSearchData?.is_sharable || false,
            is_consultation: formState.serviceSearchData?.is_consultation || false,
        };

        let errorState = false;

        setServiceDetails((prevState) => {
            let updatedState;
            if (prevState.some(item => item.service_details_id === newData.service_details_id)) {
                errorMessage("Service already exists!");
                errorState = true;
                return prevState; // No update, no clearing states
            }
            if (formState.searchList?.length === 0 && formState?.serviceSearchData === null) {
                errorMessage("Service name is empty!");
                errorState = true;
                return prevState;
            }
            updatedState = [...prevState, newData];

            return updatedState;
        });

        // Clear form fields only if no error
        if (!errorState) {
            setFormState((prevState) => ({
                ...prevState,
                serviceName: '',
                serviceSearchData: null,
                searchList: [],
                serviceSearch: '',
                serviceHead: '',
                serviceHeadCode: '',
                serviceCode: '',
            }));
        }
    }

    const AddTemplateData = () => {
        try {
            if (!formState?.templateName || !formState?.appliesTo) {
                return errorMessage('Please Enter All mandatory fields')
            }
            if(serviceDetails.length === 0){
                return errorMessage('Please Add Any Services in Service Configuration') 
            }
            let data = {
                "template_id": TempId || null,
                "template_name": (formState?.templateName ?? '').trim(),
                "template_code": formState?.templateCode || '',
                "is_active": isActive,
                "apply_for": formState?.appliesTo,
                "line_item": serviceDetails,
            }
            setisloader(true)
            RestAPIService.create(data, Serviceurls.NEW_TEMPLATE_CONFIGURATION)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        successMessage(response.data.message)
                        // setFormState((prevState) => ({ ...prevState, serviceName: '', serviceCode: '', serviceSearchData: null, searchList: [], serviceSearch: '' }));
                        history.push("/Settings/NewService/TemplateConfig")
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }


    const deleteTemplate = async () => {
        try {
            setisloader(true)
            RestAPIService.delete(`${Serviceurls.NEW_TEMPLATE_CONFIGURATION}?delete_type=template&template_id=${TempId}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        history.push("/Settings/NewService/TemplateConfig");
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteIndivudualData = async () => {
        try {
            setisloader(true);
            // if all rows are selcted it will delete the entire package
            if (((delIDs?.length || 0) === (templateLineItem?.length || 0) || (delIDs?.length || 0) === (serviceDetails?.length || 0)) && (apiDeleteIDs?.length || 0) > 0) {
                await deleteTemplate();
                return;
            }

            // this will remove the row locally without any api call
            if (Array.isArray(localDeleteIDs) && localDeleteIDs.length > 0) {
                setServiceDetails((prevState) =>
                    prevState.filter(item => !localDeleteIDs.includes(item.service_details_id))
                );
            }

            if (Array.isArray(apiDeleteIDs) && apiDeleteIDs.length > 0) {
                try {
                    const response = await RestAPIService.delete(
                        `${Serviceurls.NEW_TEMPLATE_CONFIGURATION}?delete_type=individual&id=${apiDeleteIDs.join(',')}`,
                        {}
                    );
                    if (response?.data?.status === 'success') {
                        successMessage(response.data.message);
                        closeFilter();
                        getTemplateIndividual(TempId);
                    }
                } catch (e) {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                }
            }
            else {
                closeFilter();
            }
        } catch (e) {
            errorMessage(e.message);
        } finally {
            setisloader(false);
        }
    };

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        {/* <Autocomplete
                            size='small'
                            options={department_category}
                            value={filterdepartment}
                            onChange={(event, newValue) => {
                                setFilterDepartment(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Vendor Catogory'}
                                />
                            )}
                        /> */}
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => { }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => { setFilterOpen(false) }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    const prevent = () => {
        history.push("/Settings/NewService/TemplateConfig")
    }

    return (
        <Box component={'div'} sx={{ height: '85vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => { prevent() }}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Template Configuration'}</Typography>
            </Box>

            <Box component={'div'} sx={{ height: '14vh', width: '93vw', backgroundColor: 'white', mt: "1vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Template Configuration'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                        {textBox("Template Code", 'templateCode', formState?.templateCode, '15vw', true)}
                        {textBox("Template Name*", 'templateName', formState?.templateName, '15vw')}
                        {autoComplete("Applies To*", 'appliesTo', formState?.appliesTo, formState?.ModuleType, '15vw')}
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' />} disabled={!TempId} label={"Active"} />
                    </div>
                    <div>
                        {delIDs?.length > 0 && <Button size='small' variant='contained' color='error' disabled={!commonDisable} sx={{ textTransform: 'capitalize', width: '5vw', marginRight: '0.5vw' }} onClick={() => { grpDelete() }}>Delete</Button>}
                        <Button size='small' variant='contained' disabled={serviceDetails.length <= 0 && !commonDisable} sx={{ textTransform: 'capitalize', width: '5vw', marginRight: '0.5vw' }} onClick={() => { AddTemplateData() }}>{TempId ? 'Update' : 'Save'}</Button>
                    </div>
                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '14vh', width: '93vw', backgroundColor: 'white', mt: "0.5vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Service Configuration'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                    {autoComplete("Search Service Code/Head/Name*", 'serviceSearchData', formState?.serviceSearchData, formState?.searchList, '30.3vw')}
                    {textBox("Service Name", 'serviceName', formState?.serviceName, '15vw', true)}
                    {textBox("Service Code", 'serviceCode', formState?.serviceCode, '15vw', true)}
                    <Button variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => {
                        setFormState((prevState) => ({ ...prevState, serviceName: '', serviceCode: '', serviceSearchData: null }));
                    }}>Clear</Button>
                    <Button variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '0.5vw' }} disabled={!formState?.serviceSearchData && !commonDisable} onClick={() => { AddTable() }}>Add</Button>
                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '47vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={
                        (((templateLineItem?.length === delIDs.length ) || (delIDs?.length || 0) === (serviceDetails?.length || 0)) && apiDeleteIDs.length > 0)
                            ? "Are you sure? Deleting this will remove the entire package!"
                            : "Are you sure, Do you want to delete this item?"
                    }
                    DeleteN DeleteNotify={
                        (((templateLineItem?.length === delIDs.length) || (delIDs?.length || 0) === (serviceDetails?.length || 0)) && apiDeleteIDs.length > 0)
                            ? "If you remove this, the entire package will be deleted."
                            : "If you remove this, this could affect the entire Configuration."
                    }
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteIndivudualData}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}